import { Injectable } from '@angular/core';
import { StorageService } from '../data/storage.service';
import { SubscriberService } from '../manager/subscriber.service';
import { NavController } from '@ionic/angular';
import { jwtDecode } from 'jwt-decode';
import { AlertService } from '../base/alert.service';
import { SocketService } from '../manager/socket.service';

export interface TokenPayload {
  id: number;
  collection: string;
  email: string;
  role: string;
  kuerzel?: string | null;
  iat: number;
  exp: number;
}

@Injectable({
  providedIn: 'root'
})

export class LoginService {

  constructor(
    private storage: StorageService,
    private sub: SubscriberService,
    private navCtrl: NavController,
    private alert: AlertService,
    private socketService: SocketService,

  ) { }

  public loginStatus: boolean = false;
  public loginToken: string = '';
  public decodedToken: TokenPayload | null = null;

  async checkLoginStatus() {
    const logintoken = await this.storage.getData('logintoken');
    if (logintoken) {
      this.loginToken = logintoken;
      this.loginStatus = true;
      this.decodedToken = this.getDecodedToken(logintoken);
      this.socketService.connect(logintoken);
      return true;
    } else {
      this.loginStatus = false;
      this.loginToken = '';
      this.decodedToken = null;
      return false
    }
  }

  async verifyLogin(jumpHome: boolean = false, loadAll: boolean = false) {
    const status = await this.checkLoginStatus();
    if (status) {
      if(jumpHome){
        this.navCtrl.navigateForward('/home');
      }
    } else {
      this.navCtrl.navigateForward('/login');
    }
  }

  async logmein(res:any){
    if (res.status === 200 || res.status === 201) {
      await this.updateToken(res.data.token);
      this.navCtrl.navigateForward('/home');
      return true
    }

    if (res.status === 401 || res.status === 403) {
      this.alert.presentToast('Passwort oder E-Mail ist falsch', 5000);
    }

    await this.resetToken();
    return false
  }

  async updateToken(newToken: string) {
    this.loginToken = newToken;
    this.loginStatus = true;
    await this.storage.setData('logintoken', newToken);
    this.decodedToken = this.getDecodedToken(newToken);
    this.socketService.connect(newToken);
  }

  async resetToken(backToLoin: boolean = false){
    this.loginToken = '';
    this.loginStatus = false;
    this.decodedToken = null;
    await this.storage.removeData('logintoken');
    this.socketService.disconnect();

    if(backToLoin){
      this.navCtrl.navigateForward('/login');
    }
  }

  async logoutUser() {
    // Leere die gesamte IndexedDB
    // await this.storage.clearData();
    // console.log('IndexedDB wurde geleert');

    this.resetToken(true);
  }

  getDecodedToken(tokens: string): TokenPayload | null {
    const token = tokens;
    if (!token) return null;

    try {
      return jwtDecode<TokenPayload>(token);
    } catch (e) {
      console.error('Ungültiger Token:', e);
      return null;
    }
  }

  isTokenExpired(): boolean {
    const decoded = this.decodedToken;
    if (!decoded) return true;

    const now = Math.floor(Date.now() / 1000);
    return decoded.exp < now;
  }





}
